import api from "../services/api";

const urlBase64ToUint8Array = (base64String) => {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = atob(base64);
  return Uint8Array.from([...rawData].map((c) => c.charCodeAt(0)));
};

// Usa navigator.serviceWorker.ready — aguarda o SW ficar ativo (não retorna null)
const getReadyServiceWorker = async () => {
  if (!("serviceWorker" in navigator)) return null;
  try {
    // Timeout de 8s para não travar indefinidamente
    const reg = await Promise.race([
      navigator.serviceWorker.ready,
      new Promise((_, reject) => setTimeout(() => reject(new Error("SW timeout")), 8000))
    ]);
    return reg || null;
  } catch (err) {
    console.warn("[WebPush] Service worker não ficou pronto:", err.message);
    return null;
  }
};

export const isWebPushSupported = () =>
  typeof window !== "undefined" &&
  "serviceWorker" in navigator &&
  "PushManager" in window &&
  "Notification" in window;

export const getWebPushPermission = () => {
  if (!("Notification" in window)) return "denied";
  return Notification.permission;
};

export const requestWebPushPermission = async () => {
  if (!("Notification" in window)) return false;
  const permission = await Notification.requestPermission();
  return permission === "granted";
};

export const subscribeWebPush = async () => {
  if (!isWebPushSupported()) {
    console.warn("[WebPush] Push não suportado neste browser");
    return false;
  }

  try {
    const { data } = await api.get("/webpush/vapid-public-key");
    const vapidPublicKey = data?.publicKey;
    if (!vapidPublicKey) {
      console.error("[WebPush] VAPID public key não encontrada");
      return false;
    }

    const reg = await getReadyServiceWorker();
    if (!reg) {
      console.error("[WebPush] Service worker não disponível");
      return false;
    }

    const applicationServerKey = urlBase64ToUint8Array(vapidPublicKey);

    let subscription = await reg.pushManager.getSubscription();
    if (!subscription) {
      subscription = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey
      });
    }

    await api.post("/webpush/subscribe", { subscription });
    return true;
  } catch (err) {
    console.error("[WebPush] Erro ao subscrever:", err?.message || err);
    // Relança com mensagem legível para o handler mostrar no toast
    throw err;
  }
};

export const unsubscribeWebPush = async () => {
  if (!isWebPushSupported()) return;

  try {
    const reg = await getReadyServiceWorker();
    if (!reg) return;

    const subscription = await reg.pushManager.getSubscription();
    if (!subscription) return;

    await api.delete("/webpush/subscribe", {
      data: { endpoint: subscription.endpoint }
    });
    await subscription.unsubscribe();
  } catch (err) {
    console.error("[WebPush] Erro ao cancelar subscricao:", err);
  }
};

export const ensureWebPushSubscribed = async () => {
  if (!isWebPushSupported()) return false;
  if (getWebPushPermission() !== "granted") return false;
  try {
    return await subscribeWebPush();
  } catch {
    return false;
  }
};
